const n = (o, l) => {
  const e = o !== void 0;
  return [e, e ? o : l];
};
export {
  n as useControllableProp
};
//# sourceMappingURL=useControllable.js.map
